<template>
  <div>
    <AssetBuyModal :open="modalIsOpened('addDealBuy')"
                   @close="toggleModal('addDealBuy')"/>
    <AssetSellModal :open="modalIsOpened('addDealSell')"
                    @close="toggleModal('addDealSell')"/>
    <ManualIncomesModal :open="modalIsOpened('addManualIncome')"
                        @close="toggleModal('addManualIncome')"/>
    <ManualExpensesModal :open="modalIsOpened('addManualExpense')"
                         @close="toggleModal('addManualExpense')"/>
    <ImportPortfolioModal :import-opened="modalIsOpened('importPortfolio')"
                          @close="toggleModal('importPortfolio')"/>
    <TransferInBalanceModal :open="modalIsOpened('transferInBalance')"
                            @close="toggleModal('transferInBalance')"/>
    <TransferOutBalanceModal :open="modalIsOpened('transferOutBalance')"
                             @close="toggleModal('transferOutBalance')"/>
  </div>
</template>

<script>
import {mapGetters, mapMutations} from "vuex";
import ImportPortfolioModal from "@/components/cabinet/Investments/modals/ImportPortfolioModal/ImportPortfolioModal";
import AssetBuyModal from "@/components/cabinet/Investments/modals/AssetBuyModal";
import AssetSellModal from "@/components/cabinet/Investments/modals/AssetSellModal";
import ManualExpensesModal from "@/components/cabinet/Investments/modals/ManualDealsModal/ManualExpensesModal";
import ManualIncomesModal from "@/components/cabinet/Investments/modals/ManualDealsModal/ManualIncomesModal";
import TransferInBalanceModal from "@/components/cabinet/Investments/modals/TransferInBalanceModal";
import TransferOutBalanceModal from "@/components/cabinet/Investments/modals/TransferOutBalanceModal";

/*  todo refactor as <component is/>
      AssetBuy: false,
      AssetSell: false,
      ManualIncome: false,
      ManualExpense: false,
      ImportPortfolio: false,
      TransferInBalance: false,
      TransferOutBalance: false,*/

export default {
  name: "InvestmentsModals",
  components: {
    AssetBuyModal,
    AssetSellModal,
    ImportPortfolioModal,
    ManualIncomesModal,
    ManualExpensesModal,
    TransferOutBalanceModal,
    TransferInBalanceModal,
  },
  computed: {
    ...mapGetters('investments/modals', ['modalIsOpened']),
  },
  methods: {
    ...mapMutations('investments/modals', ['toggleModal']),
  }
}
</script>

<style scoped>

</style>